import type { ReactNode } from 'react';
import { useAuth } from '../providers/AuthProvider';
import { usePermissions } from '@/hooks/usePermissions';
import AccessDenied from '@/features/error/pages/AccessDenied';

interface OwnerRouteProps {
  children: ReactNode;
}

export default function OwnerRoute({ children }: OwnerRouteProps) {
  const { isLoading } = useAuth();
  const { isOwner } = usePermissions();

  if (isLoading) return null;

  if (!isOwner) {
    return <AccessDenied />;
  }

  return <>{children}</>;
}
